<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-blur-sensitive
              v-html="clienteExibicao"
            ></h6>
            <p
              class="mb-0"
              v-if="currentUserPersonalInfo.conta"
              v-b-tooltip.html="
                dadosMascarados
                  ? 'Código da conta oculto enquanto os dados estão protegidos'
                  : currentUserPersonalInfo.conta_id ||
                    'Código da conta não informado'
              "
            >
              <span v-blur-sensitive class="font-weight-bolder">
                @{{ contaExibicao }}
              </span>
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.emailCliente }}
              </span>
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1
            "
          >
            <div class="d-flex">
              <button
                @click="trocarUsuarioOuConta"
                class="btn btn-wellon-branco btn-sm"
                :disabled="telaBloqueada"
                :title="telaBloqueada ? 'Tela bloqueada' : ''"
              >
                <i class="fas fa-arrows-to-dot"></i>
                Central de Contas
              </button>
              <button
                @click="alternarBloqueioTela"
                class="btn btn-wellon-branco btn-sm ml-3"
                :title="telaBloqueada ? 'Tela bloqueada' : 'Bloquear tela'"
              >
                <i
                  :class="
                    telaBloqueada
                      ? 'fas fa-fingerprint'
                      : 'fas fa-unlock-keyhole'
                  "
                ></i>
              </button>
            </div>
          </div>

          <!-- Bloco PROPRIO, fora do gate de troca de contas. Com o motor
          ligado a mascara vale para todo usuario, entao o controle de liberacao
          precisa existir para todo usuario: dentro do bloco anterior ele so
          aparecia para super admin e admin de conta com mais de uma conta, e o
          cliente comum ficava com o dado coberto e sem saida.

          `pl-0` porque a coluna propria somava o proprio padding ao padding da
          coluna anterior, e o vao ficava com o dobro do `ml-3` que separa
          Central de Contas do bloqueio de tela. Sem ele, sobra so o padding da
          anterior, que da praticamente a mesma distancia. -->
          <div class="col-auto pl-0">
            <botao-protecao-dados></botao-protecao-dados>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <central-contas ref="centralContas"></central-contas>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import CentralContas from "@/view/pages/painel/conta/central/CentralContas.vue";
import BotaoProtecaoDados from "@/view/components/BotaoProtecaoDados.vue";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    "central-contas": CentralContas,
    "botao-protecao-dados": BotaoProtecaoDados
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "dadosMascarados",
      "hasPermission",
      "telaBloqueada"
    ]),

    /**
     * O `con_login` para EXIBIR, que vem coberto do servidor quando e o caso.
     *
     * Campo próprio, e não o `conta`: aquele e usado como chave em varios
     * pontos do painel (chaves de localStorage dos filtros ativos, filtro de
     * template, SQLRunner) e mascara-lo faria as preferencias do usuário
     * migrarem de chave a cada troca de estado. Valor mascarado serve para ler,
     * nunca para agir.
     */
    contaExibicao() {
      return (
        this.currentUserPersonalInfo.conta_exibicao ||
        this.currentUserPersonalInfo.conta
      );
    },

    /**
     * O nome do cliente para EXIBIR, que vem coberto do servidor quando e o
     * caso.
     *
     * Campo próprio pelo mesmo motivo do `contaExibicao`: o `cliente` integro
     * e o que o widget do Atende envia no setUser a cada carga do dashboard, e
     * com o valor coberto o contato do Chatwoot nascia como
     * "João | I••••••• d• O••••••••" (WEL-5384).
     */
    clienteExibicao() {
      return (
        this.currentUserPersonalInfo.cliente_exibicao ||
        this.currentUserPersonalInfo.cliente
      );
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  },

  methods: {
    ...mapActions(["togglePresentationMode"]),

    // WEL-5192: bloqueio de tela pessoal. Só bloqueia (desbloqueio acontece
    // pelo formulário do LockOverlay, com o código do autenticador).
    alternarBloqueioTela() {
      if (this.telaBloqueada) {
        return;
      }

      if (this.currentUserPersonalInfo.canal_2fa !== "A") {
        Swal.fire({
          icon: "info",
          title: "Ative o aplicativo autenticador",
          text: "Para usar o bloqueio de tela, habilite o autenticador por app no seu perfil.",
          heightAuto: false
        });
        return;
      }

      ApiService.post("bloquear-tela").then(() => {
        this.$store.dispatch(UPDATE_PERSONAL_INFO, {
          ...this.currentUserPersonalInfo,
          tela_bloqueada: true
        });
      });
    },

    // Delegado ao componente CentralContas (extraído do Header): mantém o
    // mesmo gatilho de clique de sempre, só que agora abrindo o modal via ref
    // em vez de gerenciar o estado da lista aqui.
    trocarUsuarioOuConta() {
      this.$refs.centralContas.abrir();
    }
  }
};
</script>
